import React from 'react';
import classNames from 'classnames';
import DropdownList from '@profile/src/Components/DropdownList';
import styles from './styles.module.scss';
import icArrow from 'assets/svg/ic_arrow_fill.svg';
import CheckboxWithLabel from '../CheckboxWithLabel';
import { options } from './config';
import { TimeFilterType } from '@profile/src/utils/types';

const TimeSingleSelect = ({
  onSelect,
  className,
  value = TimeFilterType.TIME_ALL
}) => {
  const ref = React.useRef(null);
  const [collapsed, setCollapsed] = React.useState(true);
  const isCheckAll = value === TimeFilterType.TIME_ALL;
  const displayText = React.useMemo(() => {
    const selectedItem = options.find(e => value === e.id);

    if (selectedItem) {
      return selectedItem.label;
    }

    return 'All Time';
  }, [value]);

  const toggleDropdown = () => {
    setCollapsed(!collapsed);
  };

  const closeDropdown = () => {
    setCollapsed(true);
  };

  const onItemChange = item => {
    onSelect(item.id);
    closeDropdown();
  };

  React.useEffect(() => {
    function handleClickOutside(event) {
      if (ref.current && !ref.current.contains(event.target)) {
        closeDropdown();
      }
    }

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);
  return /*#__PURE__*/React.createElement("div", {
    ref: ref,
    className: classNames(styles.wrapper, className)
  }, /*#__PURE__*/React.createElement("div", {
    className: styles.container,
    onClick: e => {
      e.stopPropagation();
      toggleDropdown();
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: styles.label
  }, /*#__PURE__*/React.createElement("span", {
    className: styles.spanLabel
  }, displayText)), /*#__PURE__*/React.createElement("span", {
    className: classNames(styles.icon, !collapsed && styles.collapse)
  }, /*#__PURE__*/React.createElement("img", {
    className: styles.img,
    src: icArrow
  }))), /*#__PURE__*/React.createElement(DropdownList, {
    className: classNames(styles.dropdown, collapsed && styles.hide)
  }, /*#__PURE__*/React.createElement("div", {
    className: styles.group
  }, /*#__PURE__*/React.createElement("div", {
    className: styles.hr
  }, /*#__PURE__*/React.createElement(CheckboxWithLabel, {
    label: "All Time",
    onChange: () => {
      onSelect(TimeFilterType.TIME_ALL);
      closeDropdown();
    },
    check: isCheckAll
  }))), /*#__PURE__*/React.createElement("div", {
    className: styles.group
  }, /*#__PURE__*/React.createElement("div", {
    className: styles.hr
  }, options.map(item => /*#__PURE__*/React.createElement(CheckboxWithLabel, {
    key: item.id,
    onChange: () => {
      onItemChange(item);
    },
    label: item.label,
    check: item.id === value
  }))))));
};

export default TimeSingleSelect;